import { type CMSView } from "@firecms/core";

import PromoCodesCreate from "components/organisms/PromoCodesCreate";
import PromoCodesList from "components/organisms/PromoCodesList";
import WebDownloadsManager from "components/organisms/WebDownloadsManager";
import { Groups } from "../collections/types";
import { adminToolViews } from "./admin-tool-views";

export const websiteAdminViews: CMSView[] = [
  {
    path: "web-downloads",
    name: "Web-Downloads",
    description: "Dateien und Ordner unter `web/downloads` verwalten",
    icon: "folder",
    group: Groups.Verwaltung,
    view: <WebDownloadsManager />,
  },
  {
    path: "promo-codes-list",
    name: "Promo-Codes",
    description: "Promo-Codes anzeigen, exportieren und löschen",
    icon: "sell",
    group: Groups.Verwaltung,
    view: <PromoCodesList />,
  },
  {
    path: "promo-codes-create",
    name: "Promo-Code erstellen",
    description: "Neue Promo-Codes generieren",
    icon: "add",
    group: Groups.Verwaltung,
    view: <PromoCodesCreate />,
  },
];

export const cmsCustomViews: CMSView[] = [...websiteAdminViews, ...adminToolViews];

export const websiteAdminViewPaths = cmsCustomViews.map((view) => view.path);
